import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
  standalone:false
})
export class SelectComponent implements ControlValueAccessor {
  @Input() config: any;

  value: any; // Bound value for the select
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // Called by Angular when writing a value to the control
  writeValue(value: any): void {
    this.value = value;
  }

  // Registers a callback function that should be called when the value changes
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Registers a callback function that should be called when the control is touched
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Handles the `ionChange` event
  handleChange(event: any) {
    const selectedValue = event.detail.value; // Extract the value from event.detail
    this.value = selectedValue;
    this.onChange(selectedValue); // Notify the parent form control of the value change
    this.onTouched();
  }
}
